import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EditMeetingModalOverride } from 'Resources/Meeting';
import EditMeetingLayoutWithPicklist from 'Layouts/EditMeetingLayoutWithPicklist';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import Dialog from 'Components/UI/Dialog';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {
    overflowY: 'hidden',
  },
});

function CancelMeetingDialog({
  className,
  classes,
  resource,
  onClose,
  onDelete,
  onFailure,
  onSubmit,
  ...rest
}) {
  const [resourceWithOverride, setResource] = useState(null);

  async function loadCollection(meetingRes) {
    const [resp] = await meetingRes.link('self').get({
      metaOverrideSet: EditMeetingModalOverride,
    });

    setResource(resp);
  }

  useEffect(() => {
    loadCollection(resource);
  }, []);

  if (!resourceWithOverride) {
    return null;
  }

  return (
    <Dialog
      classes={{
        paper: classes.root,
      }}
      open
      onClose={onClose}
      variant="default"
      title="Edit Meeting"
    >
      <MetaFormInline
        resource={resourceWithOverride}
        layout={EditMeetingLayoutWithPicklist}
        noIndividualSubmitButtons
        onSubmit={(res) => {
          if (onSubmit) {
            onSubmit(res);
          }
          onClose(true);
        }}
        LayoutProps={{
          onCloseEditModal: () => onClose(),
          excludedFromRemainingFields: [
            'meetingType',
          ],
        }}
        {...rest}
      />
    </Dialog>
  );
}

CancelMeetingDialog.defaultProps = {
  className: '',
  onDelete: null,
  onFailure: null,
};

CancelMeetingDialog.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onFailure: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
};

export default withStyles(styles)(CancelMeetingDialog);
